(function($, duo, undefined) {

	"use strict";

	/**
	 * Class MediaQuery
	 */
	class MediaQuery {

		/**
		 * Gets the current media query
		 * @param {string} selector any css selector
		 * @param {string} pseudoElement pseudo element (:before/:after)
		 * @return {string} media query string
		 *
		 * this is a static method, you can call it as follows:
		 * const mq = duo.MediaQuery.getMediaQuery('body', ':before');
		 */
		static getMediaQuery(selector = 'body', pseudoElement = ':before') {
			var element = document.querySelector(selector);
			var mediaQuery = window.getComputedStyle(element, pseudoElement).getPropertyValue('content'); 
			return mediaQuery.replace(/["']/g, "");
		} /* getMediaQuery */

	} /* MediaQuery */

	duo.MediaQuery = MediaQuery;

})(jQuery, window.duo = window.duo || {});
